export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
  PHONE: /^[0-9]{10,11}$/,
  POSTAL_CODE: /^\d{3}-\d{4}$/,
  NUMBER: /^[0-9]*$/,
  DECIMAL: /^[0-9]+(\.[0-9]+)?$/,
  URL: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
  RESPONSE_20X: /^2[0-9][0-9]$/,
  RESPONSE_40X: /^4[0-9][0-9]$/
};
export const KANSAI_COMPANY = {
  ID: 1
};
